import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconColour$1 = /*@__PURE__*/ proxyCustomElement(class WppIconColour extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-colour", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M2.98274 5.2113C5.44846 1.92847 10.5531 0.973217 14.187 3.23259C17.7752 5.46357 19.0948 9.75287 17.6252 13.7774C16.2375 17.5775 12.5811 19.0832 9.94576 17.1716C8.95857 16.4555 8.57588 15.5579 8.39091 14.0998L8.30256 13.2716L8.26448 12.9383C8.16167 12.1552 8.00369 11.8044 7.67398 11.6206C7.22494 11.3703 6.92595 11.3645 6.33633 11.593L6.04196 11.7151L5.89211 11.7804C5.04217 12.1495 4.47676 12.2792 3.76161 12.1294L3.59372 12.0898L3.45662 12.0507C1.11836 11.3262 0.772026 8.1546 2.98274 5.2113ZM3.8079 10.8423L3.91094 10.8729L4.02325 10.8987C4.39137 10.9716 4.70598 10.9109 5.22804 10.696L5.7329 10.4803C6.74077 10.0671 7.39732 10.0267 8.28625 10.5221C9.05556 10.9509 9.3554 11.61 9.50833 12.752L9.55293 13.1369L9.59838 13.5827L9.6379 13.9369C9.78216 15.0781 10.0444 15.6895 10.6842 16.1536C12.5918 17.5373 15.3242 16.4121 16.4439 13.346C17.7151 9.86484 16.5899 6.20746 13.5229 4.30058C10.4425 2.38529 6.06254 3.20493 3.98828 5.96656C2.24879 8.2825 2.46214 10.3929 3.8079 10.8423ZM13.2185 9.17027C13.0687 8.6112 13.4004 8.03655 13.9595 7.88675C14.5186 7.73694 15.0932 8.06872 15.243 8.62779C15.3928 9.18686 15.0611 9.76151 14.502 9.91132C13.9429 10.0611 13.3683 9.72934 13.2185 9.17027ZM13.6331 12.0952C13.4833 11.5361 13.8151 10.9614 14.3742 10.8116C14.9332 10.6618 15.5079 10.9936 15.6577 11.5527C15.8075 12.1117 15.4757 12.6864 14.9167 12.8362C14.3576 12.986 13.7829 12.6542 13.6331 12.0952ZM11.5597 6.65283C11.4099 6.09376 11.7417 5.51911 12.3007 5.36931C12.8598 5.21951 13.4345 5.55128 13.5843 6.11035C13.7341 6.66942 13.4023 7.24408 12.8432 7.39388C12.2842 7.54368 11.7095 7.2119 11.5597 6.65283ZM11.5358 14.197C11.386 13.638 11.7178 13.0633 12.2769 12.9135C12.8359 12.7637 13.4106 13.0955 13.5604 13.6546C13.7102 14.2136 13.3784 14.7883 12.8193 14.9381C12.2603 15.0879 11.6856 14.7561 11.5358 14.197ZM8.60401 5.83825C8.45421 5.27918 8.78598 4.70453 9.34505 4.55473C9.90412 4.40493 10.4788 4.7367 10.6286 5.29577C10.7784 5.85484 10.4466 6.4295 9.88753 6.5793C9.32846 6.7291 8.75381 6.39732 8.60401 5.83825Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-colour-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-colour", "wpp-icon-colour-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-colour-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-colour-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconColour$1);
      }
      break;
  } });
}

const WppIconColour = WppIconColour$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconColour, defineCustomElement };
